export const COMMAND_START = 'start'
export const COMMAND_RESET = 'reset'
export const COMMAND_STOP = 'stop'
export const COMMAND_ALERT = 'alert'
export const COMMAND_UPDATE = 'update'
export const COMMAND_CONFIRM = 'confirm'
export const COMMAND_UNSUBSCRIBE = 'unsubscribe'